import { motion } from "framer-motion";
import { PHOTOS } from "@/data/content";

const COVERLINES = [
  { text: "The woman turning grief into hope", pos: "left-8 top-10 lg:left-16 lg:top-16" },
  { text: "580M+ views worldwide", pos: "right-8 top-10 text-right lg:right-16 lg:top-16" },
  { text: "International bestselling author", pos: "left-8 bottom-10 lg:left-16 lg:bottom-16" },
  { text: "As seen on The Drew Barrymore Show", pos: "right-8 bottom-10 text-right lg:right-16 lg:bottom-16" },
];

export default function CoverStar() {
  return (
    <section data-testid="cover-star" className="relative overflow-hidden bg-[#F7F1E6] py-24 text-[#6B5D4F] lg:py-32">
      <span
        aria-hidden="true"
        className="pointer-events-none absolute inset-0 flex select-none items-center justify-center font-display2 uppercase text-[24vw] leading-none tracking-wide text-transparent"
        style={{ WebkitTextStroke: "1px rgba(197,160,89,0.22)" }}
      >
        SUSAN
      </span>

      <div className="relative mx-auto max-w-7xl px-6 lg:px-10">
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="text-center font-body text-[0.65rem] font-medium uppercase tracking-[0.5em] text-[#C5A059]"
        >
          The Cover Star
        </motion.p>

        <div className="relative mt-10 flex justify-center">
          {COVERLINES.map((c, i) => (
            <motion.p
              key={c.text}
              data-testid={`coverline-${i}`}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8, delay: 0.3 + i * 0.12 }}
              className={`absolute z-20 hidden max-w-[11rem] font-display text-xl font-light italic leading-snug text-[#6B5D4F]/85 md:block lg:text-2xl ${c.pos}`}
            >
              {c.text}
            </motion.p>
          ))}

          <div className="relative z-10">
            <motion.div
              initial={{ clipPath: "inset(100% 0 0 0)" }}
              whileInView={{ clipPath: "inset(0% 0 0 0)" }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 1.4, ease: [0.76, 0, 0.24, 1] }}
            >
              <div className="border border-[#C5A059]/50 p-3">
                <img
                  src={PHOTOS.coverStar}
                  alt="Susan Grau at an Infinite Life, Infinite Lessons event"
                  data-testid="cover-star-photo"
                  className="h-[58vh] w-auto object-cover"
                />
              </div>
            </motion.div>
            <motion.p
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 1, delay: 0.8 }}
              className="absolute -bottom-8 left-1/2 -translate-x-1/2 font-script text-5xl text-[#C5A059] md:text-6xl"
            >
              grau
            </motion.p>
          </div>
        </div>

        <div className="mt-20 grid grid-cols-2 gap-6 md:hidden">
          {COVERLINES.map((c, i) => (
            <p key={c.text} className="font-display text-lg font-light italic leading-snug text-[#6B5D4F]/85">
              {c.text}
            </p>
          ))}
        </div>
      </div>
    </section>
  );
}
